<div class="default-detail-panel-container">
    <div class="tips">{{i18n.get('home.search_term_noResult_info')}}</div>
    <div class="item-content">
        <ul class="flex-box">
            <li
                (click)="handleSelectedResource(item)"
                *ngFor="let item of searchObject"
                class="flex-item"
            >
                <span>
                    <svg class="icon icon-large">
                        <use [attr.xlink:href]="item.icon"></use>
                    </svg>
                </span>
                <div>{{ item.title }}</div>
            </li>
        </ul>
    </div>
</div>
